import React, { Component } from 'react';
import { pushCommand, pushGroupCommand, isEmpty } from '../../../../Common/Common';
import {
	getIsShowSB, getIsShowSetpointRange, getIsShowRcProhOp, getIsShowRcProhMode, getIsShowRcProhSP,
	getIsShowRcProhFanstep
} from '../../../../Common/Common';

import Off_Timer_Duration from './Off_Timer_Duration';
import Setpoint_Range from './Setpoint_Range';
import Setback from './Setback';
import Clear_Filter from './Clear_Filter';

import RC_Proh_Op from './RC_Proh_Op';
import RC_Proh_Mode from './RC_Proh_Mode';
import RC_Proh_SP from './RC_Proh_SP';
import RC_Proh_Fanstep from './RC_Proh_Fanstep';

export default class Advanced_Settings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_show_advanced_settings: false,
		}
	}

	handleSendCommand = (command, val) => {
		// Check whether it is a point operation or group operation
		if (this.props.group_id != null) {
			pushGroupCommand(command, val, this.props.group_id);
		} else if (this.props.point_id != null) {
			this.target_id = this.props.point_id;
			pushCommand(command, val, this.props.point_id);
		}
	}

	handleToggleAdvancedSettings = () => {
		this.setState({ is_show_advanced_settings: !this.state.is_show_advanced_settings })
	}

	handleChangeOffDuration = (val) => {
		let command = 'off_duration';
		this.handleSendCommand(command, val);
	}

	handleToggleRCProhOp = (val) => {
		let command = 'rop_proh';
		this.handleSendCommand(command, val);
	}

	handleToggleRCProhMode = (val) => {
		let command = 'rmode_proh';
		this.handleSendCommand(command, val);
	}

	handleToggleRCProhSP = (val) => {
		let command = 'rsp_proh';
		this.handleSendCommand(command, val);
	}

	handleToggleRCProhFanstep = (val) => {
		let command = 'rfan_proh';
		this.handleSendCommand(command, val);
	}

	handleToggleCSPRange = (val) => {
		let command = 'csp_limit_valid';
		this.handleSendCommand(command, val);
	}

	handleToggleHSPRange = (val) => {
		let command = 'hsp_limit_valid';
		this.handleSendCommand(command, val);
	}

	handleChangeCSPRange = (val) => {
		let command = 'csp_limit';
		this.handleSendCommand(command, val);
	}

	handleChangeHSPRange = (val) => {
		let command = 'hsp_limit';
		this.handleSendCommand(command, val);
	}

	handleChangeSetbackCool = (val) => {
		let command = 'sb_csp';
		this.handleSendCommand(command, val);
	}

	handleChangeSetbackHeat = (val) => {
		let command = 'sb_hsp';
		this.handleSendCommand(command, val);
	}

	handleClearFilter = () => {
		let command = 'cl_filter';
		let val = 'on';
		this.handleSendCommand(command, val);
	}

	render() {
		// Advanced Settings only for admin
		if (this.props.receiver.active_controller.user_class != 'Admin') return null;

		let advanced_setting_button = {
			cursor: 'pointer',
			width: this.props.width - 40,
			margin: 'auto',
			padding: 5,
			textAlign: 'left',
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.45)',
			borderRadius: 10,
		}

		let collapsible_height = this.props.height - 480;
		if (collapsible_height < 150) collapsible_height = 150;

		let advanced_setting_collapsible_style = {
			maxHeight: this.state.is_show_advanced_settings ? 'unset' : 0,
			transition: 'max-height 0.6s ease-out',
			overflow: 'auto',
		}

		let advanced_setting_cell_width = this.props.width - 80;
		let advanced_setting_cell = {
			width: advanced_setting_cell_width,
			textAlign: 'left',
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 15,
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
		}

		let is_show_offtimer_duration = false;
		let is_show_setpoint_range = false;
		let is_show_setback = false;
		let is_show_rc_proh_op = false;
		let is_show_rc_proh_mode = false;
		let is_show_rc_proh_sp = false;
		let is_show_rc_proh_fanstep = false;

		let type = '';
		if (!isEmpty(this.props.point_info)) {
			type = this.props.point_info.type;
		} else if (this.props.type != null) {
			type = this.props.type;
		}

		let available_functions = this.props.receiver.active_controller.available_functions;

		switch (type) {
			case 'General':
				is_show_offtimer_duration = true;
				break;
			case 'Ac':
				// Show off timer duration if not group operation
				if (this.props.group_id == null) {
					is_show_offtimer_duration = true;
				}
				is_show_setpoint_range = getIsShowSetpointRange(available_functions);
				is_show_setback = getIsShowSB(available_functions);
				if (!isEmpty(this.props.point_info)) {
					is_show_rc_proh_op = getIsShowRcProhOp(this.props.point_info, available_functions);
					is_show_rc_proh_mode = getIsShowRcProhMode(this.props.point_info, available_functions);
					is_show_rc_proh_sp = getIsShowRcProhSP(this.props.point_info, available_functions);
					is_show_rc_proh_fanstep = getIsShowRcProhFanstep(this.props.point_info, available_functions);
				} else {
					for (let point_id of this.props.group_info.mp) {
						let point_info = window.app.state.point_list[point_id];
						if (!isEmpty(point_info)) {
							if (point_info.type == 'Ac') {
								if (!is_show_rc_proh_op) is_show_rc_proh_op = getIsShowRcProhOp(point_info, available_functions);
								if (!is_show_rc_proh_mode) is_show_rc_proh_mode = getIsShowRcProhMode(point_info, available_functions);
								if (!is_show_rc_proh_sp) is_show_rc_proh_sp = getIsShowRcProhSP(point_info, available_functions);
								if (!is_show_rc_proh_fanstep) is_show_rc_proh_fanstep = getIsShowRcProhFanstep(point_info, available_functions);
							}
						}
					}
				}
				break;
			case 'Level':
			case 'LevelSw':
			case 'Switch':
			case 'Rgbw':
			case 'Hrv':
			case 'Dehumi':
				is_show_offtimer_duration = true;
				if (!isEmpty(this.props.point_info)) {
					is_show_rc_proh_op = getIsShowRcProhOp(this.props.point_info, available_functions);
				} else {
					// For group
					is_show_rc_proh_op = true;
				}
				break;
			case 'Status':
				break;
			default:
		}

		let is_show_filter = false;
		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.filter == 'on') is_show_filter = true;
		}

		return (
			<div style={{ marginBottom: 20 }}>
				<div id='advanced_setting' style={advanced_setting_button} onClick={this.handleToggleAdvancedSettings}>
					<span className='subtitle'>{this.props.receiver.getString('advanced_settings')}</span>
				</div>
				<div style={advanced_setting_collapsible_style}>
					<div style={{ display: is_show_filter ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<Clear_Filter
							width={advanced_setting_cell_width}
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleClearFilter={this.handleClearFilter}
							colours={this.props.colours}
						/>
					</div>
					<div style={{ display: is_show_offtimer_duration ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<Off_Timer_Duration
							width={advanced_setting_cell_width}
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleChangeOffDuration={this.handleChangeOffDuration}
						/>
					</div>

					<div style={{ display: is_show_rc_proh_op ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<RC_Proh_Op
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleRCProhOp={this.handleToggleRCProhOp}
						/>
					</div>
					<div style={{ display: is_show_rc_proh_mode ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<RC_Proh_Mode
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleRCProhMode={this.handleToggleRCProhMode}
						/>
					</div>
					<div style={{ display: is_show_rc_proh_sp ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<RC_Proh_SP
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleRCProhSP={this.handleToggleRCProhSP}
						/>
					</div>
					<div style={{ display: is_show_rc_proh_fanstep ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<RC_Proh_Fanstep
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleRCProhFanstep={this.handleToggleRCProhFanstep}
						/>
					</div>
					<div style={{ display: is_show_setpoint_range ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<Setpoint_Range
							width={advanced_setting_cell_width}
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleChangeCSPRange={this.handleChangeCSPRange}
							handleChangeHSPRange={this.handleChangeHSPRange}
							handleToggleHSPRange={this.handleToggleHSPRange}
							handleToggleCSPRange={this.handleToggleCSPRange}
						/>
					</div>
					<div style={{ display: is_show_setback ? 'block' : 'none', verticalAlign: 'top', width: '100%', marginTop: 10, marginBottom: 10 }}>
						<Setback
							width={advanced_setting_cell_width}
							style={advanced_setting_cell}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleChangeSetbackCool={this.handleChangeSetbackCool}
							handleChangeSetbackHeat={this.handleChangeSetbackHeat}
						/>
					</div>
				</div>
			</div>
		)
	}
}